<bee-scroll-animation [items]="items$ | async"></bee-scroll-animation>